<template>
    <div v-show="loading" id="loading">
        <b-spinner label="Loading..." variant="primary" type="grow"></b-spinner>
    </div>
</template>

<script>
    export default {
        props: ['loading']
    }
</script>
